/* eslint-disable @stylistic/max-len */
import { UntypedFormControl, ValidationErrors } from '@angular/forms';

export function validateEmailList(c: UntypedFormControl): ValidationErrors {
  const MAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const value = <string>c.value;
  if (!value.length) {
    return null;
  }
  const contactList = value.match(/[^\(\s,;)]+/g);
  const validated = contactList.every(email => {
    return MAIL_REGEX.test(email);
  });

  return validated
    ? null
    : {
        email: {
          valid: false,
        },
      };
}
